<template>
  <div class="jnt">
    <div class="contentDiv" style="padding-bottom: 90px;">
      <div></div>
      <div>
        <div>
          <div class="content" :style="content_style">
            <div class="searchDiv">
              <div class="mourn_search_inner">
                <span @click="search()" class="weui_icon_search  icon iconfont">&#xe8b9;</span>
                <input
                  v-model="keyword"
                  type="search"
                  class="mourn_search_input"
                  id="search_input"
                  placeholder="搜索馆名"
                  style="height: 2.5rem;"
                />
              </div>
              <!-- <div class="search1 flex" style="background-color: rgba(255, 255, 255, 0.16);">
                <div class="icon-search"></div>
                <div class="search-txt">搜索馆名或人名</div>
              </div> -->
            </div>
            <div class="menuDiv">
              <lz-menu
                :menuItems="menuItems"
                :iActiveColor="iActiveColor"
                :DefaultIndex="0"
                @clickLzMenuItem="clickMenuItem"
              />
            </div>
          </div>
        </div>
        <div class="content1 head1">
          <router-view></router-view>
        </div>
      </div>
      <div>
        <section class="footDiv foot1">
          <section class="bottomMenu" style="">
            <section @click="menuClick(0)" class="menuList">
              <i class="iconfont">&#xe70c;</i>
              <span>商城</span>
            </section>
            <section @click="menuClick(1)" class="menuList">
              <i class="iconfont">&#xe8aa;</i>
              <span>服务</span>
            </section>
            <section @click="menuClick(3)" class="menuList active">
              <i class="iconfont">&#xe670;</i>
              <span>纪念堂</span>
            </section>
            <section @click="menuClick(2)" class="menuList">
              <i class="iconfont">&#xe600;</i>
              <span>我的</span>
            </section>
          </section>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import LzMenu from './Menu.vue'
export default {
  name: 'jiniantang',
  components: {
    LzMenu,
  },
  data() {
    return {
      keyword: '',
      topFlag: true,
      content_style: {
        'font-size':'14px', 
        'background-image': 'url('+this.$store.getters.banner['/jnt_background']+')'
      },
      menuItems: [
        {
          id: 1,
          name: '首页',
          path: '',
        },
        {
          id: 2,
          name: '私人馆',
          path: 'siren',
        },
        {
          id: 3,
          name: '名人馆',
          path: 'mingren',
        },
        {
          id: 4,
          name: '伟人馆',
          path: 'weiren',
        },
        {
          id: 5,
          name: '英雄馆',
          path: 'yingxiong',
        },
        {
          id: 6,
          name: '事件馆',
          path: 'shijian',
        },
        {
          id: 7,
          name: '院士馆',
          path: 'yuanshi',
        },
        {
          id: 8,
          name: '陵园',
          path: 'lingyuan',
        },
      ],
      iActiveColor: '#fff', //选中时文本为黄色
    }
  },
  methods: {
    search() {
      this.$router.push({ path: '/jnt/list/' + this.keyword })
    },
    menuClick(id) {
      if (id == 0) {
        this.$router.push({ path: '/shop' })
      } else if (id == 1) {
        this.$router.push({ path: '/shop/services' })
      } else if (id == 2) {
        this.$router.push({ path: '/my' })
      } else if (id == 3) {
        this.$router.push({ path: '/jnt' })
      }
    },
    clickMenuItem: function(item) {
      //item
      if (item.path) {
        this.$router.push({ path: '/jnt/list/' + item.path })
      } else {
        this.$router.push({ path: '/jnt' })
      }
      console.log(item)
    },
  },
  watch: {},
}
</script>

<style>
.bottomMenu {
  background-color: #fff;
  position: fixed;
  z-index: 100;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 5rem;
  display: flex;
  box-shadow: 0 -0.027rem 0.05333rem rgb(0 0 0 / 10%);
  padding: 0.5rem;
}
.bottomMenu .menuList {
  flex: 1;
  display: flex;
  text-align: center;
  flex-direction: column;
  align-items: center;
  font-size: 1.1rem;
}
.bottomMenu .menuList.active i {
  color: #dea767;
  font-size: 2.1rem;
}

.bottomMenu .menuList i {
  color: #4c4c4c;
  font-size: 2.1rem;
}

.bottomMenu .menuList .icon_style {
  width: 2.5rem;
  height: 2.5rem;
  margin-top: 0.6rem;
  fill: #ccc;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: contain;
}
.bottomMenu .menuList.active {
  font-size: 1.1rem;
  color: #323232;
}

.bottomMenu .menuList {
  font-size: 1.1rem;
  color: #999;
}
.jnt .content {
  background-color: rgb(247, 247, 247);
  background-image: url('../../assets/jnt/topbg-chun.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 18.727rem;
  width: 100%;
}
.jnt .search1 {
  height: auto;
  overflow: hidden;
  position: relative;
  padding: 0 1.363rem;
}
.jnt .search1 img {
  width: 100%;
  border-radius: 5px;
}
.searchDiv {
  position: relative;
  padding: 8px 15px;
  padding-top: 10px;
  display: flex;
  display: -webkit-flex;
  box-sizing: border-box;
}
.searchDiv .search1 {
  width: 100%;
  background: #f8f8f8;
  line-height: 3.2rem;
  border-radius: 20px;
  text-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
}
.flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}
.contentDiv .searchDiv .search1 .icon-search {
  background: url(../../assets/jnt/search.png);
  width: 1.636rem;
  height: 1.636rem;
  background-size: 100% 100%;
}
.searchDiv .search1 .icon-search {
  display: inline-block;

  width: 1.3rem;
  height: 1.35rem;
  background-size: 100% 100%;
}
.contentDiv .searchDiv .search1 .search-txt {
  color: #fff;
}
.searchDiv .search1 .search-txt {
  color: #999;
  font-size: 1.4rem;
  margin-left: 5px;
}
.contentDiv .menuDiv {
  margin-top: 0;
}
.contentDiv .menuDiv .tomb-nav {
  background: transparent;
}
.menuDiv .tomb-nav {
  list-style: none;
  font-size: 1.4rem;
  padding: 0.685rem;
  background: #fff;
  overflow: hidden;
  padding-left: 0;
}
.content1 {
  margin-top: -9.5rem;
}
.contentDiv .mainNav-marquee {
  padding: 0.45rem 1.36rem;
  box-sizing: border-box;
  line-height: 2.72rem;
  overflow: hidden;
}

.footDiv,
.foot1,
.footDiv_newyear {
  position: fixed;
  bottom: -1px;
  left: 0;
  z-index: 900;
  width: 100%;
  background: #fff;
  height: 4.525rem;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}
.footDiv .nav1,
.foot1 .nav1,
.footDiv_newyear .nav1 {
  overflow: visible;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.line2 {
  width: 100%;
  display: -webkit-box;
  position: relative;
}
.line2:before {
  content: '\20';
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
  right: 0;
  border-top: 1px solid #eeeff3;
  -webkit-transform: scaleY(0.5);
  -webkit-transform-origin: 0 0;
}
.foot1 .item2,
.footDiv_newyear .item1 {
  color: #666;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  font-size: 0.995rem;
  text-align: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  position: relative;
}
.footDiv a.item1:first-of-type span.active {
  background-image: url(../../assets/jnt/menu1-.png);
}
.footDiv a.item1:first-of-type span.bg {
  background-image: url(../../assets/jnt/menu1.png);
}
.footDiv .item1 span.bg,
.foot1 .item1 span.bg,
.footDiv_newyear .item1 span.bg {
  display: block;
  height: 24px;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 24px 24px;
  margin-bottom: 0.2rem;
}
.footDiv a.item1:first-of-type span.active + p {
  color: #e4803c;
}
.footDiv .item1 p.text,
.foot1 .item1 p.text,
.footDiv_newyear .item1 p.text {
  margin: 0;
  margin-top: 0;
  padding: 0;
}
.foot1 .item2 .btn-add,
.footDiv_qingming .item2 .btn-add {
  display: block;
  width: 3.6rem;
  height: 3.6rem;
  line-height: 4.25rem;
  text-align: center;
  border-radius: 50%;
  border: 4px solid #fff;
  margin: 0 auto;
  margin-top: -2.5rem;
  box-shadow: 0 -2px 1px -1px #eeeff3;
  -ms-flex-align: center;
  -ms-flex-pack: center;
  -webkit-align-items: center;
  -webkit-justify-content: center;
  align-items: center;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}
.foot1 .item2 .btn-add {
  background: #e4803c;
}
.foot1 .item2 .btn-add .icon-add {
  background: url(../../assets/jnt/menuadd.png) no-repeat;
  background-size: 100% 100%;
  height: 1.7rem;
  width: 1.7rem;
  display: flex;
}
.footDiv .item1 p.text,
.foot1 .item1 p.text,
.footDiv_newyear .item1 p.text {
  margin: 0;
  margin-top: 0;
  padding: 0;
}
.footDiv a.item1:nth-of-type(3) span.bg {
  background-image: url(../../assets/jnt/menu2-.png);
}
.footDiv .item1 span.bg,
.foot1 .item1 span.bg,
.footDiv_newyear .item1 span.bg {
  display: block;
  height: 24px;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 24px 24px;
  margin-bottom: 0.2rem;
}
.line2:before {
  content: '\20';
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
  right: 0;
  border-top: 1px solid #eeeff3;
  -webkit-transform: scaleY(0.5);
  -webkit-transform-origin: 0 0;
}
.footDiv .item1,
.foot1 .item1,
.foot1 .item2,
.footDiv_newyear .item1 {
  color: #666;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  font-size: 0.995rem;
  text-align: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  position: relative;
}

/* 搜索 */

.mourn_search_bar {
  position: relative;
  padding: 8px 10px;
  display: flex;
  display: -webkit-flex;
  box-sizing: border-box;
  background-color: #faf9fa;
}

.mourn_search_bar:before {
  top: 0;
  border-top: 1px solid #c7c7c7;
  transform-origin: 0 0;
  transform: scaleY(0.5);
}

.mourn_search_bar:after,
.mourn_search_bar:before {
  content: ' ';
  position: absolute;
  left: 0;
  width: 100%;
  height: 1px;
  color: #c7c7c7;
}

.mourn_search_bar:after {
  bottom: 0;
  border-bottom: 1px solid #c7c7c7;
  transform-origin: 0 100%;
  transform: scaleY(0.5);
}

.mourn_search_bar.mourn_search_focusing .mourn_search_cancel {
  display: block;
}

.mourn_search_bar.mourn_search_focusing .mourn_search_text {
  display: none;
}

.mourn_search_outer {
  position: relative;
  flex: auto;
  -webkit-flex: auto;
}

.mourn_search_outer:after {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 200%;
  height: 200%;
  transform: scale(0.5);
  transform-origin: 0 0;
  -webkit-transform: scale(0.5);
  -webkit-transform-origin: 0 0;
  border-radius: 40px;
  border: 1px solid #eee;
  box-sizing: border-box;
  background: #eee;
}
.mourn_search_inner {
  position: relative;
  padding-left: 20px;
  padding-right: 30px;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  z-index: 1;
  border-radius: 20px;
  border: 1px solid #fff;
  background: #fff;
}

.mourn_search_inner .mourn_search_input {
  padding: 4px 0;
  width: 100%;
  height: 1.42857143em;
  border: 0;
  font-size: 14px;
  line-height: 1.42857143em;
  box-sizing: content-box;
  background: transparent;
}

.mourn_search_inner .mourn_search_input:focus {
  outline: none;
}

.mourn_search_inner .weui_icon_search {
  position: absolute;
  right: 20px;
  top: 2px;
  line-height: 28px;

  color: #333;
}

.mourn_search_inner .weui_icon_clear {
  position: absolute;
  top: 4px;
  right: 0;
  padding: 0 10px;
  line-height: 28px;
}

.mourn_search_text {
  position: absolute;
  top: 1px;
  right: 1px;
  bottom: 1px;
  left: 1px;
  z-index: 2;
  border-radius: 3px;
  text-align: center;
  color: #9b9b9b;
  background: #fff;
}

.mourn_search_text span {
  display: inline-block;
  font-size: 14px;
  vertical-align: middle;
}

.mourn_search_text .weui_icon_search {
  margin-right: 5px;
}

.mourn_search_cancel {
  display: none;
  margin-left: 10px;
  line-height: 28px;
  white-space: nowrap;
  color: #fff;
}

.mourn_search_input:not(:valid) ~ .weui_icon_clear {
  display: none;
}

input[type='search']::-webkit-search-cancel-button,
input[type='search']::-webkit-search-decoration,
input[type='search']::-webkit-search-results-button,
input[type='search']::-webkit-search-results-decoration {
  display: none;
}
</style>
